import { CheckOutlined, ExclamationOutlined } from "@ant-design/icons";
import { Flex, Space, Spacing, Tooltip } from "@p0security/ui";
import React from "react";

import { colors } from "../../styles/variables";

export interface StepperSection {
  title: string;
  valid: boolean;
  touched: boolean;
  children: React.ReactNode;
}

const ICON_SIZE = "h-9 w-9";

const StepIcon: React.FC<{
  touched: boolean;
  valid: boolean;
  title: string;
}> = ({ touched, valid, title }) => {
  if (!touched) {
    return (
      <div
        className={`${ICON_SIZE} shrink-0 rounded-full border-2`}
        style={{ borderColor: colors.neutral["20"] }}
      />
    );
  }
  return (
    <Tooltip title={valid ? "Complete" : `${title} needs attention`}>
      <div
        className={`${ICON_SIZE} shrink-0 rounded-full flex items-center justify-center`}
        style={{
          backgroundColor: valid
            ? colors.success["50"]
            : colors.tagColors.red.text,
        }}
      >
        <span style={{ color: colors.neutral["00"], lineHeight: 0 }}>
          {valid ? <CheckOutlined /> : <ExclamationOutlined />}
        </span>
      </div>
    </Tooltip>
  );
};

export const EditorStepper: React.FC<{ sections: StepperSection[] }> = ({
  sections,
}) => (
  <Space direction="vertical" size={0}>
    {sections.map((section, idx) => {
      const isLast = idx === sections.length - 1;
      const lineGreen =
        !isLast &&
        section.touched &&
        section.valid &&
        sections[idx + 1].touched &&
        sections[idx + 1].valid;

      return (
        <Flex key={section.title} gap={16}>
          <Flex align="center" vertical>
            <StepIcon
              touched={section.touched}
              valid={section.valid}
              title={section.title}
            />
            {!isLast && (
              <div
                className="w-0.5 flex-1"
                style={{
                  backgroundColor: lineGreen
                    ? colors.success["50"]
                    : colors.neutral["20"],
                }}
              />
            )}
          </Flex>
          <Spacing asChild mt={8}>
            <Space
              direction="vertical"
              size="small"
              className="flex-1 max-w-200 pb-8"
            >
              <span
                className="text-sm font-semibold"
                style={{ color: colors.neutral["70"] }}
              >
                {section.title}
              </span>
              {section.children}
            </Space>
          </Spacing>
        </Flex>
      );
    })}
  </Space>
);
